/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HtmlPageConfigInfoRespVo } from './HtmlPageConfigInfoRespVo';
import {
    HtmlPageConfigInfoRespVoFromJSON,
    HtmlPageConfigInfoRespVoFromJSONTyped,
    HtmlPageConfigInfoRespVoToJSON,
    HtmlPageConfigInfoRespVoToJSONTyped,
} from './HtmlPageConfigInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseListHtmlPageConfigInfoRespVo
 */
export interface ResponseListHtmlPageConfigInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListHtmlPageConfigInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListHtmlPageConfigInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<HtmlPageConfigInfoRespVo>}
     * @memberof ResponseListHtmlPageConfigInfoRespVo
     */
    data?: Array<HtmlPageConfigInfoRespVo>;
}

/**
 * Check if a given object implements the ResponseListHtmlPageConfigInfoRespVo interface.
 */
export function instanceOfResponseListHtmlPageConfigInfoRespVo(value: object): value is ResponseListHtmlPageConfigInfoRespVo {
    return true;
}

export function ResponseListHtmlPageConfigInfoRespVoFromJSON(json: any): ResponseListHtmlPageConfigInfoRespVo {
    return ResponseListHtmlPageConfigInfoRespVoFromJSONTyped(json, false);
}

export function ResponseListHtmlPageConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListHtmlPageConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(HtmlPageConfigInfoRespVoFromJSON)),
    };
}

export function ResponseListHtmlPageConfigInfoRespVoToJSON(json: any): ResponseListHtmlPageConfigInfoRespVo {
    return ResponseListHtmlPageConfigInfoRespVoToJSONTyped(json, false);
}

export function ResponseListHtmlPageConfigInfoRespVoToJSONTyped(value?: ResponseListHtmlPageConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(HtmlPageConfigInfoRespVoToJSON)),
    };
}

